import { getJWT, getLocal } from '../Utils/Profile'
import { BASEAPI } from './constants'

const loginUserMantenedor = async (
    commerce: string,
    user: string,
    password: string
) => {
    const res = await fetch(`${BASEAPI}auth/loginv2`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body:
            'user=' + user + '&password=' + password + '&commerce=' + commerce,
    })
        .then((response) => {
            return response
        })
        .catch((error) => {
            console.log(error)
            return null
        })

    return res
}

const loginUser = async (user: string, password: string) => {
    const res = await fetch(`${BASEAPI}auth/login`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: 'user=' + user + '&password=' + password,
    })
        .then((response) => {
            return response
        })
        .catch((error) => {
            console.log(error)
            return null
        })

    return res
}

const postRestaurarClave = async (user: string, email: string) => {
    let res = null

    await fetch(`${BASEAPI}auth/restaurar-clave`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: 'user=' + user + '&email=' + email,
    })
        .then((response) => {
            res = response.status
        })
        .catch((error) => {
            console.error(error)
        })

    return res
}

const getUrlDashboard = async (commerce_internal_id: string) => {
    const res = await fetch(
        `${BASEAPI}apimac/api/v1/mac/urldashboard/store/${getLocal()}/response`,
        {
            method: 'GET',
            headers: {
                Authorization: getJWT(),
            },
        }
    )
        .then((response) => {
            return response.json()
        })
        .catch((error) => {
            console.error(error)
            return null
        })
    return res
}

export { loginUser, postRestaurarClave, getUrlDashboard, loginUserMantenedor }
